// Push Notification utilities for E-Home
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registered:', registration);
      return registration;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
      return null;
    }
  }
  return null;
};

export const showLocalNotification = (title, body, url = '/') => {
  if (Notification.permission === 'granted' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(title, {
        body,
        icon: '/logo192.png',
        badge: '/logo192.png',
        data: url,
        vibrate: [200, 100, 200]
      });
    });
  }
};

// ── Avisos al móvil (Web Push) ───────────────────────────────────────────────
//
// Lo de arriba solo enseña avisos con la app ABIERTA. Esto da de alta el
// navegador en el servidor para que lleguen aunque esté cerrada, que es lo que
// se espera de una app instalada en el móvil.
//
// La clave pública se pide al servidor y no se escribe aquí: así rotarla no
// obliga a recompilar el frontend.
import axios from 'axios';

const API_PUSH = `${process.env.REACT_APP_BACKEND_URL}/api`;

// pushManager.subscribe exige un Uint8Array; la clave viaja en base64url.
function claveAUint8(base64url) {
  const relleno = '='.repeat((4 - (base64url.length % 4)) % 4);
  const b64 = (base64url + relleno).replace(/-/g, '+').replace(/_/g, '/');
  const crudo = window.atob(b64);
  const salida = new Uint8Array(crudo.length);
  for (let i = 0; i < crudo.length; i++) salida[i] = crudo.charCodeAt(i);
  return salida;
}

function aBase64Url(buffer) {
  const bytes = new Uint8Array(buffer);
  let s = '';
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return window.btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export const suscribirAPush = async () => {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
    if (Notification.permission !== 'granted') return false;

    const { data } = await axios.get(`${API_PUSH}/push/clave`);
    if (!data?.configurado || !data?.clave) return false;

    const registro = await navigator.serviceWorker.ready;
    let sub = await registro.pushManager.getSubscription();

    // Si el servidor cambió de clave, la suscripción vieja ya no sirve y hay
    // que rehacerla; si no, los avisos se pierden en silencio.
    if (sub) {
      const actual = sub.options && sub.options.applicationServerKey;
      if (actual && aBase64Url(actual) !== data.clave) {
        await sub.unsubscribe();
        sub = null;
      }
    }
    if (!sub) {
      sub = await registro.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: claveAUint8(data.clave),
      });
    }

    const j = sub.toJSON();
    await axios.post(`${API_PUSH}/push/suscribir`, {
      endpoint: j.endpoint, keys: j.keys, user_agent: navigator.userAgent,
    });
    return true;
  } catch (e) {
    // Sin sesión da 401 y es normal: se reintenta en la siguiente carga, ya
    // dentro. No se molesta al usuario con esto.
    if (e?.response?.status !== 401) {
      console.warn('no se pudo dar de alta el aviso al móvil:', e?.message || e);
    }
    return false;
  }
};

export const avisoDePrueba = async () => {
  const { data } = await axios.post(`${API_PUSH}/push/prueba`, {});
  return data;
};
